import React from 'react';
import LetterHive from '../games/LetterHive/LetterHive';
import AdPlaceholder from '../components/AdPlaceholder';
import SeoHead from '../components/SeoHead';
import './GamePage.css';

export default function LetterHivePage() {
  return (
    <main className="game-page">
      <SeoHead
        title="Letter Hive"
        description="Spelling Bee–style hive: seven letters with a center. Form words, score pangrams, daily puzzle for everyone."
        path="/letter-hive"
      />
      <div className="game-page-ad">
        <AdPlaceholder variant="game-top" />
      </div>
      <LetterHive />
    </main>
  );
}
